import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddToCartSlice = createSlice({
    name: "addToCart",
    initialState,
    reducers: {
        addToCartRequest(state) {
            state.loading = true;
        },
        addToCartRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addToCartRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        addToCartStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    addToCartRequest,
    addToCartRequestSuccess,
    addToCartRequestError,
    addToCartStateReset
} = AddToCartSlice.actions;

export default AddToCartSlice.reducer;
